import { useNavigate } from "@tanstack/solid-router";
import { createResource, For, Show } from "solid-js";
import { ApiError, fetchMyOrders } from "~/lib/api";
import { cityLabel, TICKET_PURCHASE_URL } from "~/lib/tickets";

export function MyTicketsPage() {
  const navigate = useNavigate();
  const [orders] = createResource(fetchMyOrders);

  return (
    <section class="card">
      <p class="status-chip">Buyer</p>
      <h1>Your tickets</h1>
      <p class="muted">
        Orders purchased with this login email. Assign names for each seat, or share the personal
        assign link from the order page.
      </p>

      <Show when={orders.loading}>
        <p class="muted">Loading orders…</p>
      </Show>
      <Show when={orders.error}>
        <div class="error-box">
          {(orders.error as ApiError).message || "Could not load orders"}
        </div>
      </Show>
      <Show when={orders.state === "ready" && (orders()?.data?.length ?? 0) === 0}>
        <p>No first-party ticket orders found for this email.</p>
        <a class="btn" href={TICKET_PURCHASE_URL} target="_blank" rel="noreferrer">
          Browse 2027 tickets
        </a>
      </Show>
      <Show when={orders.state === "ready" && (orders()?.data?.length ?? 0) > 0}>
        <ul class="event-list">
          <For each={orders()!.data}>
            {(order) => (
              <li>
                <button
                  type="button"
                  class="event-pill event-pill-btn"
                  onClick={() =>
                    navigate({
                      to: "/tickets/$orderId",
                      params: { orderId: order.order_id },
                    })
                  }
                >
                  <div>
                    <strong>{order.event_name}</strong>
                    <div class="muted">
                      {cityLabel(order.event_id)}
                      <Show when={order.event_date_label}> · {order.event_date_label}</Show>
                    </div>
                    <div class="muted">
                      {order.quantity} seat{order.quantity === 1 ? "" : "s"} · {order.status}
                      {" · "}
                      {order.seats.filter((s) => s.assigned).length}/{order.seats.length} named
                    </div>
                  </div>
                </button>
              </li>
            )}
          </For>
        </ul>
      </Show>
    </section>
  );
}
